<button rds-dropdown-toggle-primary-button  size="l" [rdsMenuTriggerFor]="createContentMenu">Create Content</button>
<rds-menu #createContentMenu="rdsMenu" xPosition="before" size="l" class="app-menu">
  <button rds-menu-item size="l" [routerLink]="item.path" rnbBackButtonSet [label]="'RocheHome Workspace'"
          [routeBack]="'workspace'" [routeCurrent]="item.path" *ngFor="let item of menuItems" [disabled]="item.blocked">
    <rds-icon class="action" namespace="outlined" [icon]="item.icon"></rds-icon>
    {{item.title}}
  </button>
</rds-menu>
